module.exports = __webpack_public_path__ + "media/images/img_mv_mansion_purchasing-6dbc113f22b50e682ac24dab7c2a3aba.png";